module.exports = __webpack_public_path__ + "img/icon-hint.303880c7.png";